import React from 'react';
import { Row, Col } from 'react-bootstrap';
import './EmployeeDashboard.css';

const MetricCircle = ({ value, label, type, total, progress }) => (
  <div className="metric-wrapper">
    <div className={`metric-circle ${type}`}>
      <div className="metric-value">{value}</div>
      {progress !== undefined && (
        <div className="metric-progress">
          <div 
            className="metric-progress-bar" 
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
    </div>
    <div className="metric-label">{label}</div>
  </div>
);

const PerformanceMetrics = ({ 
  totalTasks,
  completedTasks,
  inProgressTasks,
  todoTasks,
  tasksDueSoon,
  completionRate
}) => {
  return (
    <Row className="performance-metrics g-4">
      <Col xs={6} md={2}>
        <MetricCircle
          value={totalTasks}
          label="Total Tasks"
          type="primary"
          progress={100}
        />
      </Col>
      <Col xs={6} md={2}>
        <MetricCircle
          value={completedTasks}
          label="Completed"
          type="success"
          progress={(completedTasks / totalTasks) * 100}
        />
      </Col>
      <Col xs={6} md={2}>
        <MetricCircle
          value={inProgressTasks}
          label="In Progress"
          type="info"
          progress={(inProgressTasks / totalTasks) * 100}
        />
      </Col>
      <Col xs={6} md={2}>
        <MetricCircle
          value={todoTasks}
          label="To Do"
          type="secondary"
          progress={(todoTasks / totalTasks) * 100}
        />
      </Col>
      <Col xs={6} md={2}>
        <MetricCircle
          value={tasksDueSoon}
          label="Due Soon"
          type="warning"
          progress={(tasksDueSoon / totalTasks) * 100}
        />
      </Col>
      <Col xs={6} md={2}>
        <MetricCircle
          value={`${completionRate}%`}
          label="Completion Rate"
          type="rate"
          progress={completionRate}
        />
      </Col>
    </Row>
  );
};

export default PerformanceMetrics; 